import { PrimaryButton } from "@/components/buttons/PrimaryButton"
import { useState } from "react"

export const BulkUploadEmployeePage = () => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);



    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
        }
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            setSelectedFile(event.dataTransfer.files[0]);
        }
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const handleSubmit = () => {
        if (selectedFile) {
            console.log("Submitting file:", selectedFile.name);
            // In a real application, you would send this file to a backend API
            alert(`File "${selectedFile.name}" submitted!`);
        } else {
            alert("Please select a file to upload.");
        }
    };

    const TEMPLATE_OPTIONS = [
        {
            title: "Sample File",
            description: "CSV containing sample data and accepted values",
        },
        {
            title: "Bulk Upload Template",
            description: "Empty CSV file to import your data",
        },
    ]

    return (
        <div className="w-full flex flex-col min-h-screen">
            <div className="w-full flex flex-col items-center justify-center max-w-[620px] mx-auto mt-6">
                <div className="flex flex-col gap-y-4 items-center justify-center mt-8">
                    <h2 className="font-clash-display text-2xl font-semibold text-medium-dark-grey">Bulk Upload</h2>
                    <p className="font-clash-display text-sm font-regular text-medium-dark-grey">Add multiple employee records quickly.</p>
                </div>

                {/* Templates Section */}
                <div className="mt-8 w-full rounded-lg border border-stroke bg-white">
                    <div className="px-6 py-4 border-b border-stroke">
                        <h4 className="font-clash-display text-base font-semibold text-medium-dark-grey mb-2">Templates</h4>
                        <p className="font-clash-display text-sm font-regular text-medium-dark-grey">Use the template to format your information correctly before uploading.</p>
                    </div>

                    {/* Sample File */}
                    {TEMPLATE_OPTIONS.map((option) => (
                        <div className="flex items-center justify-between px-6 py-4 border-b border-stroke">
                            <div className="flex items-center gap-x-3">
                                <img src="/assets/icons/document-solid.svg" alt="file icon" className="w-5 h-5 text-gray-600" />
                                <div className="flex flex-col">
                                    <p className="font-clash-display text-sm font-medium text-medium-dark-grey">{option.title}</p>
                                    <p className="font-clash-display text-sm font-regular text-medium-dark-grey">{option.description}</p>
                                </div>
                            </div>
                            <div className="border flex flex-row items-center cursor-pointer justify-center gap-x-1 border-primary-button rounded-lg px-4 py-3">
                                <p className="font-clash-display text-sm font-medium text-primary-button">Download</p>
                                <img src="/assets/icons/dropdown-arrow-green.svg" alt="download icon" className=" text-primary-button" />
                            </div>
                        </div>))}


                </div>

                {/* Upload Area */}
                <div
                    className="w-full flex flex-col items-center justify-center p-10 border-2 border-dashed border-navy-blue rounded-lg bg-baby-blue cursor-pointer text-center gap-y-2 mt-6"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onClick={() => document.getElementById('fileInput')?.click()}
                >
                    <img src="/assets/icons/document-solid.svg" alt="upload icon" className="w-8 h-8 text-primary-button" />
                    <p className="font-clash-display text-sm font-medium text-medium-dark-grey">
                        Click here or drag and drop to upload
                    </p>
                    <p className="font-clash-display text-xs font-regular text-medium-dark-grey">.CSV format (max size 10MB)</p>
                    {selectedFile && (
                        <p className="font-clash-display text-xs text-primary-button mt-2">Selected file: {selectedFile.name}</p>
                    )}
                    <input
                        type="file"
                        id="fileInput"
                        accept=".csv"
                        className="hidden"
                        onChange={handleFileChange}
                    />
                </div>

                {/* Submit Button */}
                <div className="flex justify-center mt-6 w-full">
                    <PrimaryButton
                        title="Submit to PenCom"
                        onClick={handleSubmit}
                        className="w-full"
                    />
                </div>
            </div>
        </div>
    )
}